// src/theme.js
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'light',

    primary: {
      main: '#020B3A', // Deep navy
    },

    secondary: {
      main: '#00A2FF', // Electric blue
    },

    background: {
      default: '#F5F5F7',
      paper: '#FFFFFF',
    },

    text: {
      primary: '#111827',
      secondary: '#4B5563',
    },

    divider: 'rgba(148,163,184,0.4)',
  },

  typography: {
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'system-ui',
      'sans-serif'
    ].join(','),

    h6: {
      fontWeight: 600,
      letterSpacing: '0.02em',
    },

    button: {
      textTransform: 'uppercase',
      letterSpacing: '0.12em',
      fontWeight: 500,
      fontSize: '0.78rem',
    },

    body2: {
      fontSize: '0.9rem',
    },
  },

  zIndex: {
    appBar: 1200,
    drawer: 1100,
  },

  shape: {
    borderRadius: 8,
  },

  shadows: [
    'none',
    '0px 1px 3px rgba(0, 0, 0, 0.12)',          // level 1
    '0px 4px 12px rgba(0, 0, 0, 0.12)',         // level 2
    ...Array(22).fill('0px 18px 40px rgba(0,0,0,0.12)'), // levels 3–24
  ],

  components: {
    MuiAppBar: {
      styleOverrides: {
        root: { boxShadow: 'none' },

      },
    },

    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 999,
          paddingInline: 20,
        },
        containedPrimary: {
          background: 'linear-gradient(90deg, #00A2FF, #4FD1FF)',
          boxShadow: '0px 10px 25px rgba(0,162,255,0.35)',
        },
      },
    },

    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: 12,
        },
      },
    },

    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 10,
        },
      },
    },
  },
});

export default theme;
